const observerSymbol = Symbol('mgRevealObserver');

function ensureObserver() {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    return null;
  }
  if (window[observerSymbol]) return window[observerSymbol];

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  window[observerSymbol] = observer;
  return observer;
}

export default {
  bind(el, binding) {
    el.classList.add('mg-reveal');
    if (binding.value && typeof binding.value === 'string') {
      el.setAttribute('data-reveal', binding.value);
    }
    if (binding.arg) {
      el.setAttribute('data-delay', binding.arg);
    }

    const reduce =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce) {
      el.classList.add('is-visible');
      return;
    }

    const observer = ensureObserver();
    if (observer) {
      observer.observe(el);
    } else {
      el.classList.add('is-visible');
    }
  },
  unbind(el) {
    const observer =
      typeof window !== 'undefined' ? window[observerSymbol] : null;
    if (observer) observer.unobserve(el);
  },
};
